<template>
  <div class="input-box">
    <div>
      <label>
        <p>タイトル：</p>
        <input type="text"
        v-model="inputAboutTitle" required>
      </label>
      <label>
        <p>コメント：</p>
        <textarea
        v-model="inputAboutComment" required></textarea>
      </label>
    </div>
    <div class="input-box-btns">
      <button @click="cancel">キャンセル</button>
      <template v-if="editModeA">
        <button @click="editShioriAbout">編集</button>
      </template>
      <template v-else>
        <button @click="newShioriAbout">決定</button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputAboutTitle: "",
      inputAboutComment: "",
    }
  },
  computed: {
    aboutObjects: {
      get() {
        return this.$store.getters.aboutObjects;
      },
    },
    editIndexA: {
      get() {
        return this.$store.getters.editIndexA;
      },
    },
    editModeA: {
      get() {
        return this.$store.getters.editModeA;
      },
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.inputAboutTitle = "";
      this.inputAboutComment = "";
    },
    newShioriAbout() {
      if (this.inputAboutTitle === "" | this.inputAboutComment === "") {
        alert("入力されていない項目があります");
        return;
      }
      console.log(this.inputAboutComment);
      this.$emit('new-shiori-about', this.inputAboutTitle, this.inputAboutComment);
      this.inputAboutTitle = "";
      this.inputAboutComment = "";
    },
    editShioriAbout() {
      if (this.inputAboutTitle === "" | this.inputAboutComment === "") {
        alert("入力されていない項目があります");
        return;
      } else {
        this.$emit('edit-object', this.inputAboutTitle, this.inputAboutComment);
        this.inputAboutTitle = "";
        this.inputAboutComment = "";
      }
    }
  },
  watch: {
    editModeA: function() {
      const vm = this;
      if (vm.editModeA === true) {
        vm.inputAboutTitle = vm.aboutObjects[vm.editIndexA].title;
        vm.inputAboutComment = vm.aboutObjects[vm.editIndexA].comment;
      } else {
        vm.inputAboutTitle = "";
        vm.inputAboutComment = "";
      }
    }
  }
}
</script>
